import { Prisma } from '.prisma/client';
import { Tag } from '@/prisma/utils/tag';
import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { Input } from '@chakra-ui/input';
import { Wrap } from '@chakra-ui/layout';
import {
	Tag as TagComponent, TagCloseButton, TagLabel
} from '@chakra-ui/tag';
import {
	KeyboardEvent, KeyboardEventHandler, useEffect, useState 
} from 'react';

type TagFormControlProps = {
	tags: Tag[],
	onTagsChange: (tags: (Tag | Prisma.TagCreateInput)[]) => void;
}

const TagFormControl: React.FC<TagFormControlProps> = ({ onTagsChange, ...props }) => {
	const [tags, setTags] = useState<(Tag | Prisma.TagCreateInput)[]>(props.tags || []);

	const handleRemoveTagClick = (tag: Tag | Prisma.TagCreateInput) => {
		setTags(tags.filter(t => t.name !== tag.name));
	};

	const handleOnAddTagKeyDown: KeyboardEventHandler<HTMLInputElement> = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			const target = e.target as HTMLInputElement;
			const name: string = target.value;

			if (!name || name.length < 2 || tags.find((_t) => _t.name === name)) {
				return;
			}

			setTags([...tags, {
				name,
				slug: name
			}]);
			target.value = '';
		}
	};

	useEffect(() => {
		onTagsChange(tags);
	}, [onTagsChange, tags]);

	return (
		<FormControl mt={4}>
			<FormLabel>Tags</FormLabel>
			<Wrap
				spacing={2}
				mb={2}
			>
				{tags.map(_t => <TagComponent
					key={_t.name}
					size="lg"
					borderRadius="full"
					colorScheme="pink"
				>
					<TagLabel>{_t.name}</TagLabel>
					<TagCloseButton onClick={() => (handleRemoveTagClick(_t))} />
				</TagComponent>)}
			</Wrap>
			<Input
				placeholder="Add a tag"
				onKeyDown={handleOnAddTagKeyDown}
			/>
		</FormControl>
	);
};

export default TagFormControl;
